<script>
    import { ErrorBag } from '@/system/helpers/Validate';
    import DatePicker from '../global/form/DatePicker.vue';
    import TimePicker from '../../components/mixins/TimePicker.vue';
    import Avatar from '../global/Avatar.vue';
    import TextareaAutosize from '../global/form/TextareaAutosize.vue';
    import clone from 'lodash/clone';
    import find from 'lodash/find';
    import eventGroupService from '../events/eventGroupService';
    import moment from 'moment';
    import InfiniteLoading from './InfiniteLoading'
    import { http } from '@/system/http';

    export default {
        props: {
            user: {
                required: true
            },

            currentEvent: {
                required: false,
                default: () => {},
            },

            eventGroup: {
                required: false,
                default: () => {},
            },

            value: {
                required: false,
                default: () => []
            },

            formErrors: {
                required: false,
                default: () => new ErrorBag(),
            }
        },

        mixins: [TimePicker],

        data() {
            return {
                showNewEventForm: false,
                hasEventChanges: false,
                events: [],
                event: {},
                loading: false,
                recurring_active: false,
                recurring_interval: 7,
                recurring_until: "",
                events_sorted_slice : 5,
                selectedSession: null
            }
        },

        mounted() {
            this.$event_bus.$on('showCreateEvent', ({ start, end }) => {
                if (typeof start !== 'undefined' && typeof end !== 'undefined') {
                    this.event.date = start.format("DD-MM-YYYY");
                    this.event.start = start.format("HH:mm");
                    this.event.endDate = end.format("DD-MM-YYYY");
                    this.event.end = end.format("HH:mm");
                }

                const midnight = '00:00';

                if (this.event.start === midnight) {
                    this.event.start = this.user.calendarstarttime;
                }

                if (this.event.end === midnight) {
                    this.event.end = this.user.calendarendtime;
                }

                this.events_sorted_slice = 5;
                this.showNewEventForm = true;
            });

            this.$event_bus.$on('eventSessionUpdated', (index, event) => {
                if (this.eventGroup && this.eventGroup.id === event.event_group_id) {
                    this.events[index] = event
                }
            });

            this.resetFields();

            if (this.eventGroup && this.eventGroup.id) {
                this.loadEventGroupSessions();
            }

            this.$event_bus.$on('resetSessions', () => {
                this.events = [];
            });
        },

        methods: {
            loadEventGroupSessions() {
                this.loading = true;

                eventGroupService.getSessions(this.eventGroup.id)
                    .then(({data}) => {
                        this.loading = false;
                        this.events = data.map(event => {
                            event.event_group = { ...this.eventGroup };
                            return event;
                        });
                    });
            },

            saveEventGroupSessions(events) {
                const data = events.map((event) => {
                    const data = {
                        name: event.name,
                        start: event.start,
                        end: event.end,
                        notes: event.notes,
                    }

                    if (event.id) {
                        data.id = event.id
                    }

                    return data
                })

                if (events.length === 1) {
                    this.confirmEventGroupConversion();
                } else {
                    this.loading = true;
                    eventGroupService.updateSessions(this.eventGroup.id, data)
                    .then(({data}) => {
                        this.loading = false;
                        this.$event_bus.$emit('calendarReload');
                        this.$emit('event-sessions-updated', events);
                        toastr.success(data.success);
                        swal.close();
                        this.loadEventGroupSessions();
                    }).catch(({error, errorBag}) => {
                        this.loading = false;
                        if (errorBag.has('events')) {
                            swal({
                                title:  errorBag.first('events'),
                                type : 'warning',
                            });
                        }
                    });
                }
            },

            confirmEventGroupConversion() {
                swal({
                    title: trans('event_groups.convert_event_group_title', { event_group_label: trans('event_groups.hardcoded_label') }),
                    text: trans('event_groups.convert_event_group', { event_group_label: trans('event_groups.hardcoded_label') }),
                    showCancelButton: true,
                    cancelButtonText: trans('global.cancel'),
                    showLoaderOnConfirm: true,
                    closeOnConfirm: false,
                }, () => {
                    this.deleteEventAndConvertEventGroup();
                })
            },

            deleteEventAndConvertEventGroup() {
                http.post(`/app/event/${this.events[0].id}/delete-and-convert-group`)
                    .then(() => {
                        swal.close();
                        this.$event_bus.$emit('calendarReload');
                        $('#event-modal').modal('hide');
                        $('#event-session-modal').modal('hide');
                    })
                    .catch(() => {});
            },

            getEventDateFormatted(date) {
                return date.length == 19
                    ? moment(date, serverDatetimeFormat).locale(moment_locale).format('LL')
                    : moment(date, frontDateFormat).locale(moment_locale).format('LL');
            },

            getTimeFormatted(date) {
                return date.length == 19
                    ? moment(date, serverDatetimeFormat).locale(moment_locale).format('HH:mm')
                    : moment(date).locale(moment_locale).format('HH:mm');
            },

            transformEventInputData(event) {
                return {
                    name: event.name,
                    notes: event.notes,
                    start: moment(`${event.date} ${event.start}`, `${frontDateFormat} HH:mm`).format(serverDatetimeFormat),
                    end: moment(`${event.endDate} ${event.end}`, `${frontDateFormat} HH:mm`).format(serverDatetimeFormat),
                };
            },

            transformEventDataToInput(event) {
                return {
                    name: event.name,
                    notes: event.notes,
                    date: moment(event.start, serverDatetimeFormat).format(frontDateFormat),
                    start: moment(event.start, serverDatetimeFormat).format('HH:mm'),
                    endDate: moment(event.end, serverDatetimeFormat).format(frontDateFormat),
                    end: moment(event.end, serverDatetimeFormat).format('HH:mm'),
                };
            },

            removeEvent(index, event) {
                const text = this.isEditingEventGroup
                    ? trans('event_groups.delete_session_description', { name: event.name, group_name: this.eventGroup.name })
                    : trans('event_groups.delete_session', { name: event.name })

                swal({
                        title: trans('event_groups.delete_session_title'),
                        text,
                        showCancelButton: true,
                        html: true,
                        cancelButtonText: trans('global.cancel'),
                        showLoaderOnConfirm: this.events.length > 2,
                        closeOnConfirm: false,
                    }, () => {
                        if (this.isEditingEventGroup) {
                            let cloned_events = clone(this.events);

                            cloned_events.splice(index, 1);
                            this.saveEventGroupSessions(cloned_events);
                        } else {
                            this.events.splice(index, 1);
                            this.$emit('input', this.events);

                            if (this.isEditingSession) {
                                this.selectedSession = null
                            }

                            swal.close();
                        }

                        this.formErrors.clear();
                    });
            },

            editSession(index, event) {
                if (this.isEditingEventGroup) {
                    this.$event_bus.$emit('editEventSession', index, event);
                } else {
                    const startDate = moment(event.start).locale(moment_locale)
                    const endDate = moment(event.end).locale(moment_locale)
                    this.event = {
                        ...event,
                        date: startDate.format('DD-MM-YYYY'),
                        start: startDate.format('HH:mm'),
                        endDate: endDate.format('DD-MM-YYYY'),
                        end: endDate.format('HH:mm')
                    }
                    this.selectedSession = index
                    this.recurring_active = false
                    document.getElementById('session-form').scrollIntoView();
                }
            },

            addEvent() {
                if (this.isEditingEventGroup) {
                    let cloned_events = clone(this.events);
                    cloned_events.push(this.transformEventInputData(this.event));
                    this.saveEventGroupSessions(cloned_events);
                    this.showNewEventForm = false;
                } else {
                    if (this.recurring_active) {
                        var currDate = moment(this.event.date, 'DD-MM-YYYY');
                        var lastDate = moment(this.recurring_until, 'DD-MM-YYYY');

                        var iterator_1 = 1;
                        var iterator_2 = 'days';
                        var count = 0;

                        if (this.recurring_interval == 7) {
                            var iterator_1 = 1;
                            var iterator_2 = 'weeks';
                        } else if (this.recurring_interval == 14) {
                            var iterator_1 = 2;
                            var iterator_2 = 'weeks';
                        } else if (this.recurring_interval == 21) {
                            var iterator_1 = 3;
                            var iterator_2 = 'weeks';
                        } else if (this.recurring_interval == 28) {
                            var iterator_1 = 4;
                            var iterator_2 = 'weeks';
                        } else if (this.recurring_interval == 30) {
                            var iterator_1 = 1;
                            var iterator_2 = 'months';
                        }

                        while (currDate.isSameOrBefore(lastDate) && count < 500) {
                            let cloned_event = clone(this.event);
                            cloned_event.date = currDate.format('DD-MM-YYYY');
                            cloned_event.endDate = currDate.format('DD-MM-YYYY');
                            this.events.push(this.transformEventInputData(cloned_event));
                            count++;
                            currDate = currDate.add(iterator_1, iterator_2);
                        }

                    } else {
                        if (this.isEditingSession) {
                            this.events[this.selectedSession] = this.transformEventInputData(this.event);
                        } else {
                            this.events.push(this.transformEventInputData(this.event));
                        }
                    }

                    this.$emit('input', this.events);
                    this.resetFields();
                }
            },

            resetFields() {
                this.event = {
                    name: '',
                    notes: '',
                    date: this.event.date ? this.event.date : moment().add(1, 'day').format(frontDateFormat),
                    start: this.event.start ? this.event.start : this.available_times[0],
                    endDate : this.event.date ? this.event.date : moment().add(1, 'day').format(frontDateFormat),
                    end: this.event.end ? this.event.end : moment(this.available_times[0], 'HH:mm').add(1, 'hour').format('HH:mm'),
                };
                this.selectedSession = null
                this.recurring_active = false
            },

            updateEndTime() {
                let newEndTime = moment(this.event.start,'HH:mm').add(60, 'minutes').format('HH:mm');

                if (newEndTime > this.available_times[this.available_times.length - 1]) {
                    newEndTime = this.available_times[this.available_times.length - 1];
                }

                this.event.end = newEndTime;
            },

            hasError(field) {
                return !! this.firstError(field);
            },

            firstError(field) {
                if (this.formErrors && this.formErrors.items && this.formErrors.items.length) {
                    let error = find(this.formErrors.items, {field: field});

                    if (error) {
                        return error.msg;
                    }
                }

                return null;
            }
        },

        computed: {
            available_times() {
                return this.get_available_times(this.user.calendarstarttime, this.user.calendarendtime);
            },

            isEditingEventGroup() {
                return this.eventGroup && this.eventGroup.id > 0;
            },

            hasAtLeastTwoEvents() {
                return this.events.length > 1;
            },

            hasAtLeastOneInvoicedSignup() {
                return this.currentEvent
                    && this.currentEvent.event_signups.filter(signup => signup.invoiceline != null).length > 0;
            },

            canEditSessions() {
                return !this.event.id || this.event.editable || this.isEditingSession;
            },

            eventsSorted() {
                return this.events.sort(function (left, right) {
                    return moment(left.start).diff(moment(right.start));
                }).slice(0, this.events_sorted_slice);
            },

            invalidTime() {
                return this.event.start >= this.event.end;
            },

            isEditingSession() {
                return this.selectedSession !== null
            },

            available_end_times () {
                const availableStartTimes = this.available_times;
                // find index of this.booking.start_time and return the array after that index
                const findIndex = availableStartTimes && availableStartTimes.findIndex(time => time === this.event.start);
                // remove all the times before the start time
                if (findIndex === availableStartTimes.length - 1) {
                    return availableStartTimes.slice(findIndex);
                } else {
                    return availableStartTimes.slice(findIndex + 1);
                }
            }
        },

        watch: {
            'event.date': function (newDate) {
                this.event.endDate = newDate;
            },

            'event.start': function (start) {
                this.updateEndTime();
            },
            value(events) {
                this.events = events
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('showCreateEvent');
            this.$event_bus.$off('eventSessionUpdated');
            this.$event_bus.$off('resetSessions');
        },

        components: {
            DatePicker,
            TimePicker,
            TextareaAutosize,
            Avatar,
            InfiniteLoading,
        },
    }
</script>

<template id="grouped-events">
<div class="grouped-events">
    <div v-if="loading">
        <div class="text-center">
            <div class="preloader"></div>
        </div>
    </div>

    <div class="text-left" v-if="!loading && isEditingEventGroup">
        <h4 class="control-label m-b-0">{{ trans('event_groups.created_sessions') }}</h4>
        <p class="text-muted help-block m-t-0 m-b-20">{{ trans('event_groups.sessions_overview', {event_group_label: trans('event_groups.hardcoded_label').toLowerCase() }) }}</p>
    </div>

    <ep-banner v-show="errors.has('events')" variant="danger">{{ errors.first('events') }}</ep-banner>

    <div class="row" v-show="!loading && !showNewEventForm">
        <div class="col-sm-12 text-left">
            <button class="m-b-15 m-l-0 btn btn-custom create-new-event-button add-event-button" @click="showNewEventForm = true"><i class="fa-regular fa-plus m-r-10"></i>{{ trans('event_groups.add_new_session') }}</button>
        </div>
    </div>



    <form id="session-form" class="card-box bg-box" @submit.prevent="addEvent" v-show="!loading && showNewEventForm">

        <div class="row">
            <div class="col-xs-12" v-if="!isEditingEventGroup">
                <h3 class="header-title">{{ $filters.capitalize(trans('event_groups.create_sessions_title', {event_group_label: trans('event_groups.hardcoded_label').toLowerCase() })) }}</h3>
                <p class="text-muted help-block m-t-0 m-b-10">{{ trans('event_groups.create_sessions_desc', {event_group_label: trans('event_groups.hardcoded_label').toLowerCase() }) }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-6 col-sm-4">
                <div class="form-group" :class="{ 'has-error' : errors.has('date') }">
                    <label class="control-label">{{ trans('events.name') }}</label>
                    <input type="text"  v-model="event.name" autocomplete="off" class="form-control" name="name" id="event_name"  value="" required />
                </div>
            </div>
            <div class="col-xs-6 col-sm-3">
                <div class="form-group " :class="{ 'has-error' : errors.has('date') }">
                    <label for="event-date" class="control-label">{{ $filters.capitalize(trans('global.date')) }}</label>
                    <date-picker id="event-date" :name="'date'" v-model="event.date" required></date-picker>
                </div>
            </div>
            <div :class="{ 'col-xs-10 col-sm-4' : !isEditingEventGroup && !isEditingSession, 'col-xs-12 col-sm-5' : isEditingEventGroup || isEditingSession }">
                <div class="row" :class="{'has-error': errors.has('start') || errors.has('end') || invalidTime}">
                    <div class="col-xs-6">
                        <div class="form-group ">
                            <label for="start-time" class="control-label">{{ $filters.capitalize(trans('global.from')) }}</label>
                            <select class="form-control p-5" id="start-time" name="start" v-model="event.start" required>
                            <option v-for="available_time in available_times" :value="available_time" :key="available_time">{{ available_time}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="form-group">
                            <label for="end-time" class="control-label">{{ $filters.capitalize(trans('global.to')) }}</label>
                            <select class="form-control p-5" id="end-time" name="end" v-model="event.end" required>
                                <option v-for="available_time in available_end_times" :value="available_time" :key="available_time">{{ available_time}}</option>
                            </select>
                        </div>
                    </div>
                    <span v-show="errors.has('end') || errors.has('start') || invalidTime" class="col-xs-12 help-block">
                        {{  errors.has('end')
                                ? errors.first('end')
                                : errors.has('start')
                                    ? errors.first('start')
                                    : trans('validation.before', {attribute: trans('global.start'), date: trans('global.end')})
                        }}
                    </span>
                </div>
            </div>

            <div class="col-xs-2 col-sm-1" v-if="!isEditingEventGroup && !isEditingSession">
                <a :class="{ 'active' : recurring_active }" @click.prevent="recurring_active = !recurring_active" class="p-l-0 p-r-0 btn btn-default btn-icon pull-right btn-block repeat-booking" :title="trans('events.create_event_label_repeat_2')" style="margin-top:27px;"><i class="fa fa-repeat"></i></a>
            </div>

            <div class="col-xs-12" v-if="recurring_active && !isEditingEventGroup">
                <div class="form-group repeat_options_wrap">
                    <label for="" class="control-label">{{ trans('calendar.create_close_label_repeat') }}</label>

                    <div class="form-inline">
                        <span>{{ trans('event_groups.add_this_session') }}</span>
                        <select name="" id="" class="form-control m-l-10 m-r-10" v-model="recurring_interval">
                            <option value="1">{{ trans('calendar.create_client_repeat_option_every_day') }}</option>
                            <option value="7">{{ trans('calendar.create_client_repeat_option_every_week') }}</option>
                            <option value="14">{{ trans('calendar.create_client_repeat_option_every_2_week') }}</option>
                            <option value="21">{{ trans('calendar.create_client_repeat_option_every_3_week') }}</option>
                            <option value="28">{{ trans('calendar.create_client_repeat_option_every_4_week') }}</option>
                            <option value="30">{{ trans('calendar.create_client_repeat_option_every_month') }}</option>
                        </select>

                        {{ trans('calendar.create_client_repeat_untill') }}

                        <date-picker
                            id="event-repeat-date"
                            name="date-repeat"
                            v-model="recurring_until"
                            :min_date="event.date"
                            class="m-l-10 m-r-10 inline-block align-middle"
                        ></date-picker>

                    </div>
                </div>
            </div>

            <div class="col-xs-12">
                <div class="form-group">
                    <label for="event_description" class="control-label">{{ trans('event_groups.description') }}</label>
                    <textarea-autosize id="event_description"  name="event-description" v-model="event.notes" class="form-control" style="min-height:56px;"></textarea-autosize>
                </div>
            </div>

            <div class="col-sm-12">
                <button v-if="!isEditingSession" class="m-0 pull-right btn btn-custom add-event-button" :disabled="invalidTime">
                    <i class="fa-regular fa-plus m-r-10"></i>
                    {{ trans('event_groups.add_new_session') }}
                </button>
                <button v-else class="m-0 pull-right btn btn-custom add-event-button" :disabled="invalidTime">
                    <i class="zmdi zmdi-check m-r-10"></i>
                    {{ trans('event_groups.confirm_changes') }}
                </button>

                <button v-if="isEditingSession" @click="resetFields" class="mr-5 pull-right btn">{{ trans('app.cancel_button') }}</button>
            </div>
        </div>
    </form>

    <div class="row" v-show="!loading && eventsSorted.length > 0">
        <div class="m-t-10 created-events col-xs-12 m-b-0">
            <ep-banner class="m-b-30" v-if="isEditingEventGroup && event.editable && hasAtLeastOneInvoicedSignup">
                {{ trans('event_groups.unable_to_edit_sessions') }}
            </ep-banner>

            <div v-if="!isEditingEventGroup">
                <label class="control-label m-b-0">{{ trans('event_groups.created_sessions') }}</label>
                <p class="text-muted help-block m-t-0 m-b-10">{{ trans('event_groups.sessions_overview', {event_group_label: trans('event_groups.hardcoded_label').toLowerCase() }) }}</p>
            </div>

            <ep-banner v-if="!hasAtLeastTwoEvents">{{ trans('event_groups.at_least_two_sessions', {event_group_label: trans('event_groups.hardcoded_label').charAt(0).toUpperCase() + trans('event_groups.hardcoded_label').slice(1) }) }}</ep-banner>


            <div class="created-events-container">
                <infinite-loading
                    :is-loading="false"
                    :has-finished-loading="eventsSorted.length < events.length"
                    :isDropdown="false"
                    @load-more="events_sorted_slice = events_sorted_slice + 5">

                    <div class="card-box flex p-b-10 card-box-has-close bg-box" v-for="(event, index) in eventsSorted" :key="index">
                        <div class="row flex-1" style="min-width: 0;">
                            <div class="col-xs-12 text-left event-info">

                                <strong class="truncate m-b-2">
                                    <span class="event-number" >{{ index + 1 }}. </span>
                                    {{event.name}}
                                </strong>

                                <small class="m-b-5">{{ getEventDateFormatted(event.start) }}
                                    {{ trans('global.from') }}
                                    {{ getTimeFormatted(event.start) }}
                                    {{ trans('global.to') }}
                                    {{ getTimeFormatted(event.end) }}
                                </small>
                                <p v-if="hasError(`events.${index}.end`)" class="text-danger">{{ firstError(`events.${index}.end`) }}</p>

                                <span v-if="event.practitioners && event.practitioners.length > 0" class="truncate session-employee">
                                    <avatar :url="event.practitioners[0].profile_image_url" style="border: 0 !important; margin-right: 5px;"></avatar>
                                    {{ event.practitioners[0].realname }}
                                </span>

                            </div>
                            <div class="col-xs-12 m-b-5" v-if="event.notes">
                                <small class="m-b-5 text-muted truncate">{{ event.notes }}</small>
                            </div>

                        </div>
                        <div v-if="canEditSessions" class="edit-answer flex-none" style="width: 72px; margin-left:20px;">
                            <a href="" class="btn btn-default btn-trans btn-sm m-r-5" @click.prevent="editSession(index, event)"><i class="zmdi zmdi-edit"></i></a>
                            <a href="" class="btn btn-default btn-trans btn-sm" @click.prevent="removeEvent(index, event)"><i class="fa fa-trash"></i></a>
                        </div>
                    </div>

                </infinite-loading>

            </div>
        </div>
    </div>
</div>
</template>
